import { useMemo } from "react"
import {
  Block,
  Button,
  ButtonProps,
  HeadingMedium,
  ParagraphLarge,
  useStyletron,
} from "@mezo-org/mezo-clay"
import { Link } from "@tanstack/react-router"

import bannerImage from "#/assets/home-hero-section.svg"
import {
  selectIsConnected,
  setOpenModal,
  useDappDispatch,
  useDappSelector,
} from "#/redux-state"
import { routes } from "#/shared/constants"
import { getCurrencySymbol } from "#/shared/utils"

export default function OverviewBorrowBanner() {
  const isConnected = useDappSelector(selectIsConnected)

  const dispatch = useDappDispatch()
  const [, theme] = useStyletron()

  const ctaButtonProps: ButtonProps = useMemo(
    () => ({
      overrides: {
        BaseButton: {
          style: () => ({ width: "260px" }),
          ...(isConnected
            ? { props: { "data-attr": "borrow_musd-modal" } }
            : {}),
        },
      },
      ...(isConnected
        ? { $as: Link, href: routes.BORROW }
        : { onClick: () => dispatch(setOpenModal("onboarding")) }),
    }),
    [dispatch, isConnected],
  )

  return (
    <Block
      marginTop={isConnected ? theme.sizing.scale900 : 0}
      width="100%"
      backgroundColor={theme.colors.backgroundTertiary}
      padding={`${theme.sizing.scale1200} ${theme.sizing.scale900} 78px`}
      position="relative"
      overflow="hidden"
      overrides={{
        Block: { style: () => ({ borderRadius: theme.borders.radius500 }) },
      }}
    >
      <HeadingMedium marginBottom={theme.sizing.scale600}>
        Borrow with your Bitcoin, <br />
        buy items in the Mezo Market.
      </HeadingMedium>
      <ParagraphLarge marginBottom={theme.sizing.scale900}>
        You can use {getCurrencySymbol("mBTC")} as collateral to borrow{" "}
        {getCurrencySymbol("MUSD")}
        <br /> to spend or donate in the Mezo Market for exclusive items.
      </ParagraphLarge>
      <Button {...ctaButtonProps}>
        {isConnected ? `Borrow ${getCurrencySymbol("MUSD")}` : "Sign in"}
      </Button>
      <Block
        as="img"
        src={bannerImage}
        position="absolute"
        display={["none", "none", "none", "block"]}
        right="-30%"
        top="-20%"
      />
    </Block>
  )
}
